import Analytic from './Analytic.js';

// eslint
/* global initChromecastMux */
/* eslint-disable no-use-before-define, no-param-reassign */

function parseVideoData(mediaInformation) {
    mediaInformation = mediaInformation || {};
    const customData = mediaInformation.customData || {};
    const customDataPauseOverlay = customData.pauseOverlay || {};

    const data = {
        videoId: mediaInformation.contentId || '',
        videoDuration: mediaInformation.duration || mediaInformation.customData.duration || null,
        videoTitle: mediaInformation.metadata.title || customDataPauseOverlay.title || ''
    };
    return data;
}

export default class MUX extends Analytic {
    /**
     * Create MUX Analytics
     * @param {Object} options
     * @param {Logger} logger
     */
    constructor(options, logger) {
        super(options, logger);
        this.name = 'MUX';
        this.initMux();
    }

    /**
     * Initialize events
     */
    initEvents() {
        this.logger.info(`Initialize ${this.name} Analytics Events`, this.options);

        this.playerManager.addEventListener(
            cast.framework.events.EventType.PLAYER_LOADING,
            (event) => {
                this.playerLoadingEvent(event);
            }
        );
    }

    playerLoadingEvent() {
        this.setVideoChangeData();
    }

    initMux() {
        initChromecastMux(this.playerManager, {
            debug: false,
            automaticVideoChange: false,
            data: {
                env_key: this.options.accessTokenID, // required
                // Metadata
                player_name: 'Chromecast',
                player_init_time: Date.now()
            }
        });
        modifyChromecastMux(this.playerManager);
    }

    setVideoChangeData() {
        const { playerManager } = this;
        const mediaInformation = playerManager.getMediaInformation();
        const videoData = parseVideoData(mediaInformation);
        sendFakeRequestLoadToMux(playerManager);

        const videoAttrs = {
            video_id: videoData.videoId,
            video_duration: videoData.videoDuration,
            video_title: videoData.videoTitle
        };

        if (playerManager.mux.isFirstPlay) {
            playerManager.mux.emit('loadstart', videoAttrs);
            playerManager.mux.isFirstPlay = false;
        } else {
            playerManager.mux.emit('videochange', videoAttrs);
            playerManager.mux.emit('loadstart');
        }
        playerManager.mux.emit('play');
    }
}

/**
 * To modify Chromecast Mux, that we can improve sending events for "videochange" event by self
 */
function modifyChromecastMux(playerManager) {
    const originalListener = playerManager.muxListener;
    playerManager.removeEventListener(cast.framework.events.category.CORE, originalListener);
    playerManager.removeEventListener(cast.framework.events.category.FINE, originalListener);
    playerManager.removeEventListener(cast.framework.events.category.DEBUG, originalListener);

    const modifiedMuxListener = decorateMuxListener(originalListener, playerManager);
    playerManager.addEventListener(cast.framework.events.category.CORE, modifiedMuxListener);
    playerManager.addEventListener(cast.framework.events.category.FINE, modifiedMuxListener);
    playerManager.addEventListener(cast.framework.events.category.DEBUG, modifiedMuxListener);

    playerManager.muxListener = modifiedMuxListener;
    playerManager.mux.isFirstPlay = true;
}

/**
 * Decorates originalMuxListener to control a procedure bound on LOAD REQUEST event by own way
 */
function decorateMuxListener(originalMuxListener) {
    return function (event) { // eslint-disable-line
        if (event.type === cast.framework.events.EventType.REQUEST_LOAD) {
            if (!event.isHandyGeneratedEvent) {
                return; // don't propagate native REQUEST_LOAD event to originalMuxListener
            }
        }
        originalMuxListener(event);
    };
}

/**
 * Sends own Request Load into Chromecast MUX to set inner variables
 */
function sendFakeRequestLoadToMux(playerManager) {
    const mediaInformation = playerManager.getMediaInformation();
    const requestLoadEvent = createRequestLoadEvent(mediaInformation);
    const originalMuxEmit = playerManager.mux.emit;
    playerManager.mux.emit = () => {}; // turn off emitter
    playerManager.muxListener(requestLoadEvent);
    playerManager.mux.emit = originalMuxEmit; // turn on emitter
}

/**
 * Creates own Request Load
 */
function createRequestLoadEvent(mediaInformation) {
    const event = new cast.framework.events.RequestEvent(
        cast.framework.events.EventType.REQUEST_LOAD
    );
    event.requestData = new cast.framework.messages.LoadRequestData();
    event.requestData.media = mediaInformation;
    event.isHandyGeneratedEvent = true;
    return event;
}
